import type { IFilesState } from './interfaces';

export const initState: IFilesState = {
  files: null,
  lastFetchedDay: null,
  lastAttemptDay: null,
  FetchFilesOncePerDayAsyncStatus: 'IDLE',
  error: null,
};


